import { createAction } from '@reduxjs/toolkit';

const prefix = '@config/';

export const setSearchFinishedReturnFields = createAction(`${prefix}SET_SEARCH_FINISHED_RETURN_FIELDS`);
export const setUseUrlHistory = createAction(`${prefix}SET_USE_URL_HISTORY`);
export const setConfigValue = createAction(`${prefix}SET_CONFIG_VALUE`);
export const toggleTooltips = createAction(`${prefix}TOGGLE_TOOLTIPS`);
